import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CurrenciesService} from "@core/services/backend/common/service/currencies.service";
import {Currency} from "@core/services/backend/common/interface/currencies";

@Component({
    selector: 'vex-currencies-create-update',
    templateUrl: './currencies-create-update.component.html',
    styleUrls: ['./currencies-create-update.component.scss']
})
export class CurrenciesCreateUpdateComponent implements OnInit {

    form: FormGroup;
    mode: 'create' | 'update' = 'create';

    constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
                private dialogRef: MatDialogRef<CurrenciesCreateUpdateComponent>,
                private fb: UntypedFormBuilder,
                private translateService: TranslateService,
                private snackbar: MatSnackBar,
                private currencies: CurrenciesService) {
    }

    ngOnInit() {
        // Normalizar el ID (manejar tanto 'id' como 'ID')
        const currencyId = this.defaults?.id !== undefined ? this.defaults.id : (this.defaults?.ID !== undefined ? this.defaults.ID : null);
        
        if (this.defaults && currencyId) {
            this.mode = 'update';
            // Normalizar el objeto para usar siempre 'id' en minúsculas
            if (this.defaults.ID && !this.defaults.id) {
                this.defaults.id = this.defaults.ID;
            }
        } else {
            this.mode = 'create';
            if (!this.defaults) {
            this.defaults = {} as Currency;
            }
        }

        this.form = this.fb.group({
            id: [currencyId || null],
            name: [this.defaults.name || '', [Validators.required]],
            code: [this.defaults.code || '', [Validators.required]],
            symbol: [this.defaults.symbol || ''],
            active: [this.defaults.active !== false]
        });
    }

    save() {
        if (this.mode === 'create') {
            this.create();
        } else if (this.mode === 'update') {
            this.update();
        }
    }

    create() {
        const currency = this.form.value;
        delete currency.id;
        this.currencies.create(currency).subscribe({
            next: (result) => {
                this.snackbar.open('Moneda creada correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al crear la moneda', '', {
                    duration: 3000
                });
            }
        });
    }

    update() {
        const currency = this.form.value;
        // Validar que el id existe antes de actualizar
        if (!currency.id || currency.id === null) {
            // Si no hay id, crear en lugar de actualizar
            this.create();
            return;
        }
        this.currencies.update(currency).subscribe({
            next: (result) => {
                this.snackbar.open('Moneda actualizada correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                console.error('Error al actualizar la moneda:', err);
                this.snackbar.open('Error al actualizar la moneda', '', {
                    duration: 3000
                });
            }
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}

